import { TreeNode } from '../route-builder';

export const LegalEntitiesModule = {
  segment: 'legal-entities',
  params: ['are']
} as const satisfies TreeNode;
